'use strict';

var getIn = require('lodash/get');

var getSigniantCommunicationServiceVersion = function getSigniantCommunicationServiceVersion(device) {
    return getIn(device, 'deviceVersions.signiantCommunicationService');
};
var getSdcxVersion = function getSdcxVersion(device) {
    return getIn(device, 'deviceVersions.MEDIASHUTTLE_STORAGE_SERVER');
};

module.exports = {
    getSigniantCommunicationServiceVersion: getSigniantCommunicationServiceVersion,
    getSdcxVersion: getSdcxVersion
};